// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"284":"f43e89ab","508":"f43e89ab"}[chunkId] + ".css";
};